import React from 'react';
import './Header.css';

const Header = () => {
    return (
        <div className="blog-header">
            <div id='header__background-img'/>

            <div className='header__content'>
                <h1 id='header__title'>Blog</h1>
            </div>
        </div>
    );
};

export default Header;
